import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';


const Step = () => {
  console.log(123);
  return (
    <div style={{ overflowY: 'scroll', height: '79vh' }}>
      Раздел этапа в разработке.
    </div>
  );
};


export default withRouter(Step);
